//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import UMUM from  '../../../library/umum'
import WILAYAH from  '../../../library/getWilayah'
import uniqid from 'uniqid';

export default {
  data() {
    return {

        form : {
            id : '',
            m_ipd_variabel : '',
            uraian : '',
            keterangan: '',
            createdAt : '',
            des_kel : '',
            kecamatan : '',
            status : 0,
            score : '',
            tahun : '',
        },

        pertanyaan : {
            id : '',
            m_ipd_indikator : '',
            uraian : '',
            createdAt : '',

        },







        list_data : [],
        list_data_pertanyaan : [],
        page_limit : 8,
        page_first: 1,
        page_last: 0,
        cari_value: "",
        cek_load_data : true,


        mdl_add: false,
        mdl_edit: false,
        mdl_hapus : false,
        mdl_lihat : false,
        btn_add: false,

        UMUM : UMUM,


        disable_kec : false,
        disable_des : false,
    }
  },
  methods: {


    getView : function(){
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_srv_ipd_master_indikator + "list_indikator", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              kecamatan : this.form.kecamatan,
              des_kel : this.form.des_kel,
              tahun : this.form.tahun,
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.list_data = res_data;
              console.log(res_data);
              this.$store.commit("hideLoading");
      });
    },


    



    selectData : function(data){

            this.form.id = data.id;
            this.form.m_ipd_variabel = data.m_ipd_variabel;
            this.form.uraian = data.uraian;
            this.form.score = data.score;
            this.form.status = data.status;
            this.form.keterangan= data.keterangan;
            this.form.createdAt = data.createdAt;
            this.pertanyaan.m_ipd_indikator = data.id
            this.getView_pertanyaan();
    },

    emptytData : function(data){
             this.form.id = '';
            this.form.m_ipd_variabel = '';
            this.form.uraian = '';
            this.form.score = '';
            this.form.keterangan= null;
            this.form.createdAt = '';
    },



    getView_pertanyaan : function(){
      fetch(this.$store.state.url.URL_srv_ipd_master_indikator + "view_pertanyaan", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              m_ipd_indikator: this.pertanyaan.m_ipd_indikator,
              des_kel : this.form.des_kel,
              tahun : this.form.tahun,
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.list_data_pertanyaan = res_data;
              console.log(res_data);
      });
    },



    addData_pertanyaan : function(number) {
        this.form.createdAt = UMUM.NOW()
        fetch(this.$store.state.url.URL_srv_ipd_ipd + "addData", {
            method: "POST",
            headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
              form : this.form,
              pertanyaan : this.list_data_pertanyaan
            })
        }).then(res_data => {
            this.Notify('Sukses Menambah Data', 'primary', 'check_circle_outline');
            this.getView();
        });

        // console.log(document.getElementById("editor").value)
    },






    // ====================================== PAGINATE ====================================
        Notify : function(message, positive, icon){
          this.$q.notify({
            message: message,
            color: positive,
            icon: icon,
            position : 'top',
            timeout: 500,
          })
        },

        cari_data : function(){
            this.page_first = 1;
            this.getView();
        },

        indexing : function(index){
            var idx = ((this.page_first-1)*this.page_limit)+index
            return idx
        },

        checkData : function(data){
          if (this.form.des_kel == null || this.form.des_kel == undefined || this.form.des_kel == '') {
            alert ("MOHON PILIH DESA TERLEBIH DAHULU")
          } else {
            this.selectData(data)
            this.mdl_lihat = true;
          }
        },




    // ====================================== PAGINATE ====================================

    chageDesa(){
      this.form.des_kel = ''
      if (this.form.kecamatan == '' || this.form.kecamatan == undefined || this.form.kecamatan == null) {
        WILAYAH.postDesKelAutocomplete();
      } else {
        WILAYAH.postDesKelAutocomplete(this.form.kecamatan);
        
      }
    },



    tunggu : async function(){
          await WILAYAH.getListKecamatan();
          await WILAYAH.getListDesKelFull();

          if (profile.des_kel == null || profile.des_kel == undefined || profile.des_kel == '') {
            console.log(this.$store.state.listDesKel[0].uniqid)
            this.form.des_kel = this.$store.state.listDesKel[0].uniqid
          } else {
            this.form.des_kel = profile.des_kel
          }
        },









        filterSelect : function(profile){
          if (profile.aksesWilayah == 0) {
            WILAYAH.getListDesKelFull();
            this.form.des_kel = profile.des_kel
            this.disable_des = true
            this.disable_kec = true
          } else if (profile.aksesWilayah == 1) {
            this.form.kecamatan = profile.kecamatan
            WILAYAH.postDesKel(profile.kecamatan)
            this.disable_kec = true
            this.disable_des = false

          } else if (profile.aksesWilayah == 2) {
            WILAYAH.getListDesKelFull();
            this.disable_kec = false
            this.disable_des = false
          }
        },




  },

  mounted () {

        this.form.tahun = UMUM.getTahun();

        WILAYAH.getListKecamatan();


        var profilex = JSON.parse(localStorage.profile)
        var profile = profilex.profile
        this.$store.state.ID_DES_KEL = profile.des_kel
      
   
        this.filterSelect(profile)



        this.getView();


      
  },
}
